<div class="flex flex-col p-6">
    <div class="mb-6">
        <h3 class="text-xl font-semibold text-gray-800">
            {{ promotionData ? 'Edit Promotion' : 'Create Promotion' }}
        </h3>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-4">
        <div class="grid grid-cols-2 gap-4">
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Code <span class="text-red-500">*</span></label>
                <input type="text" formControlName="code" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 outline-none" />
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Name <span class="text-red-500">*</span></label>
                <input type="text" formControlName="name" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 outline-none" />
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Type <span class="text-red-500">*</span></label>
                <select formControlName="type" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 bg-white outline-none">
                    <option value="percent">Percent</option>
                    <option value="fixed">Fixed</option>
                </select>
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Value <span class="text-red-500">*</span></label>
                <input type="number" formControlName="value" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 outline-none" />
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Max Discount ($)</label>
                <input type="number" formControlName="max_discount" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 outline-none" />
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Usage Limit</label>
                <input type="number" formControlName="usage_limit" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 outline-none" />
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Starts At</label>
                <input type="datetime-local" formControlName="starts_at" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 outline-none" />
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Ends At</label>
                <input type="datetime-local" formControlName="ends_at" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 outline-none" />
            </div>
        </div>

        <div class="flex items-center gap-2 mt-2">
            <input type="checkbox" formControlName="is_active" id="promoisActive" class="w-4 h-4 text-blue-600 rounded focus:ring-blue-500" />
            <label for="promoisActive" class="text-sm font-medium text-gray-700">Active</label>
        </div>

        <div class="flex justify-end gap-3 pt-6 border-t mt-6">
            <button type="button" (click)="cancel.emit()" class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition">Cancel</button>
            <button type="submit" [disabled]="form.invalid" class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg disabled:opacity-50 hover:bg-blue-700 transition">Save</button>
        </div>
    </form>
</div>
